<template>
  <div class="bq-page" :class="{ 'bq-wireless-page': isMobile }">
    <banner
      class="bq-banner"
      type="horizontal"
      :cover="banner.cover"
      :mcover="banner.mcover"
    >
      <img
        class="bq-banner-img"
        :src="banner.title.url"
        :alt="banner.title.text"
        slot="content"
      />
      <button
        class="bq-banner-extra"
        @click="handleJump('/service')"
        slot="extra"
        v-if="!isMobile"
      >
        了解更多
      </button>
    </banner>

    <!-- 产品和服务 -->
    <box
      class="bq-box-service bq-row"
      :title="serviceData.title"
      :desc="serviceData.subtitle"
    >
      <horizontal-card
        class="bq-box-item"
        v-for="(product, idx) in serviceData.products"
        :key="idx"
        :cover="product.img"
        :title="product.title"
        :flip="idx % 2 === 1"
        isLink
        :link="product.path"
      >
        <p slot="content">{{ product.desc }}</p>
        <i slot="extra" class="bq-card-arrow" v-if="!isMobile"></i>
      </horizontal-card>
    </box>

    <!-- 新闻动态 -->
    <box
      class="bq-box-news"
      :title="newsData.title"
      :desc="newsData.subtitle"
      v-if="!isMobile"
    >
      <div class="bq-row">
        <card
          :class="!isMobile ? 'bq-box-left-item' : 'bq-box-item'"
          layout="vertical"
          size="large"
          :cover="newsData.news[0].cover"
          :title="isMobile ? newsData.news[0].title : ''"
          isLink
          :link="newsData.news[0].path"
        >
          <h3 class="bq-box-item-title" slot="title" v-if="!isMobile">
            {{ newsData.news[0].title }}
          </h3>
          <p slot="content" v-if="isMobile">{{ newsData.news[0].desc }}</p>
        </card>

        <div :class="{ 'bq-box-right-wrapper': !isMobile }">
          <card
            class="bq-box-item"
            :layout="!isMobile ? 'horizontal' : 'vertical'"
            size="default"
            v-for="(item, index) in newsData.news.slice(1, 3)"
            :key="index"
            :cover="item.cover"
            :title="item.title"
            isLink
            :card-link="item.path"
          >
            <p class="bq-box-item-content" slot="content">{{ item.desc }}</p>
          </card>
        </div>
      </div>
    </box>

    <!-- mobile swipe -->
    <box
      class="bq-box-news"
      :title="newsData.title"
      :desc="newsData.subtitle"
      :extra="newsData.extra"
      v-else
    >
      <van-swipe :autoplay="0" @change="onNewsChange">
        <van-swipe-item v-for="(item, index) in newsData.news" :key="index">
          <card
            class="bq-box-item"
            layout="vertical"
            :cover="item.cover"
            isLink
            :link="item.path"
          >
            <h3 class="bq-box-item-title" slot="title">
              {{ item.title }}
            </h3>
          </card>
        </van-swipe-item>

        <div class="bq-indicator" slot="indicator">
          <span>{{ currentNews }}</span>
          <span class="bq-indicator-seprate">/</span>
          <span>{{ newsData.news.length }}</span>
        </div>
      </van-swipe>
    </box>

    <!-- 关于我们 -->
    <box
      class="bq-box-about"
      :title="aboutData.title"
      :desc="aboutData.subtitle"
      v-if="!isMobile"
    >
      <div class="bq-row">
        <hgroup class="bq-slogan">
          <h3>我们的理念</h3>
          <h4>{{ aboutData.slogan }}</h4>
        </hgroup>

        <div class="bq-join-us">
          <p v-for="(item, idx) in aboutData.joinus" :key="idx">{{ item }}</p>
          <button @click="handleJump('/about')">加入我们</button>
        </div>

        <div class="bq-box-environment">
          <card
            class="bq-box-item"
            layout="vertical"
            size="small"
            v-for="(item, index) in aboutData.abouts.slice(0, 3)"
            :key="index"
            :cover="item.cover"
          >
            <span class="bq-tag" slot="tag">{{ item.tag }}</span>
            <h4 class="bq-box-item-title" slot="title">{{ item.title }}</h4>
          </card>
        </div>
      </div>
    </box>

    <template v-else>
      <box class="bq-box-about" v-if="isMobile">
        <hgroup class="bq-slogan">
          <h3>我们的理念</h3>
          <h4>{{ aboutData.slogan }}</h4>
        </hgroup>
      </box>

      <box
        class="bq-box-about"
        :title="aboutData.title"
        :desc="aboutData.subtitle"
        :extra="aboutData.extra"
      >
        <van-swipe :autoplay="0" @change="onAboutChange">
          <van-swipe-item
            v-for="(item, index) in aboutData.abouts.slice(0, 3)"
            :key="index"
          >
            <card class="bq-box-item" layout="vertical" :cover="item.cover">
              <span class="bq-tag" slot="tag">{{ item.tag }}</span>
              <h3 class="bq-box-item-title" slot="title">{{ item.title }}</h3>
            </card>
          </van-swipe-item>

          <div class="bq-indicator" slot="indicator">
            <span>{{ currentAbout }}</span>
            <span class="bq-indicator-seprate">/</span>
            <span>{{ aboutData.abouts.length }}</span>
          </div>
        </van-swipe>
      </box>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';
import Banner from '@/components/Banner';
import Box from '@/components/Box';
import HorizontalCard from '@/components/HorizontalCard';
import Card from '@/components/Card';
import { isWirelessDevice } from '../../../utils/utils';

import { banner } from './home.js';
import { serviceData } from '../Service/service.js';
import { newsData } from '../News/news.js';
import { aboutData } from '../About/about.js';

Vue.use(Swipe).use(SwipeItem);

export default {
  name: 'home',

  components: {
    Box,
    Banner,
    HorizontalCard,
    Card,
  },

  data() {
    return {
      isMobile: false,
      banner,
      serviceData,
      newsData,
      aboutData,
      currentNews: 1,
      currentAbout: 1,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  methods: {
    handleJump(path) {
      location.href = path;
    },

    onNewsChange(index) {
      this.currentNews = index + 1;
    },

    onAboutChange(index) {
      this.currentAbout = index + 1;
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
